<p-dialog [header]="editMode ? 'Редактировать трек' : 'Добавить трек'" [(visible)]="visible" [modal]="true"
     [maximizable]="true" (onHide)="hideDialog()">
    <div>
        <div class="pb-4">
            <label class="lbl" for="trackNum">Трек-номер:</label>
            <input pInputText id="trackNum" name="trackNum" class="w-full" type="text" [(ngModel)]="tracknum">
        </div>

        <div>
            <label class="lbl">Описание:</label>
            <textarea pInputText id="trackDescr" name="trackDescr" class="w-full" rows="5"
                [(ngModel)]="title"></textarea>
        </div>
    </div>

    <ng-template #footer>
        @if(editMode) {
        <p-button (click)="editTrack()" label="Сохранить" />
        } @else {
        <p-button (click)="addTrack()" label="Сохранить" />
        }
        <p-button severity="secondary" (click)="hideDialog()" label="Отменить"></p-button>
    </ng-template>
</p-dialog>